import { render, staticRenderFns } from "./BloqueMapa.vue?vue&type=template&id=49466696&scoped=true"
import script from "./BloqueMapa.vue?vue&type=script&lang=js"
export * from "./BloqueMapa.vue?vue&type=script&lang=js"
import style0 from "./BloqueMapa.vue?vue&type=style&index=0&id=49466696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49466696",
  null
  
)

export default component.exports